<template>
    <v-dialog-old ref="dialog" id="decline">
        <label>Причина</label>
        <input v-model="text" type="text" placeholder="Укажите причину">
        <template v-slot:footer>
                    <button  @click="redBtnClick" class="red">{{rBtn}}</button>
                    <button @click="hide">Вернуться</button>
        </template>

    </v-dialog-old>
</template>

<script>

export default {
    props: {
        rBtn:
            {
                type: String,
                default: ''
            },
        comment:
            {
                type: String,
                default: ''
            }
    },
    data: function () {
        return {
            text: this.comment,
        };
    },

    methods: {
        show() {
            this.$refs.dialog.show();
        },
        hide() {
            this.$refs.dialog.hide();
        },
        redBtnClick() {
            this.$emit('decline',this.text);
        },



    },

    computed: {

    }
}
</script>

<style>
#decline {
    width: 680px
}
</style>
